import React, { createContext, useContext, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode"; // Ensure you have jwt-decode installed
import { useNavigate } from "react-router-dom";
import UserContext from "../context/UserContext";

const AuthContext = createContext({
  isAuthenticated: false,
  userRole: null,
  handleLogin: () => {},
  handleLogout: () => {},
});

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const navigate = useNavigate();
  const { userDetail } = useContext(UserContext);

  useEffect(() => {
    checkAuthStatus();

    // Set up a listener for storage events
    const handleStorageChange = (event) => {
      if (event.key === "access_token" && !event.newValue) {
        // If access_token is removed, update the auth state
        handleLogout();
      }
    };

    window.addEventListener("storage", handleStorageChange);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const checkAuthStatus = () => {
    const token = localStorage.getItem("access_token");
    const flag = localStorage.getItem("flag");

    if (token && flag) {
      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        if (decodedToken.expires > currentTime) {
          setIsAuthenticated(true);
          setUserRole(flag);
          navigateToDashboard(flag);
        } else {
          handleLogout(); // Token expired, log out
        }
      } catch (error) {
        console.error("Failed to decode token:", error);
        handleLogout(); // Failed to decode token, log out
      }
    } else {
      // No token found, do not call handleLogout; stay on the current screen
      setIsAuthenticated(false);
      setUserRole(null);
    }
  };

  const navigateToDashboard = (flag) => {
    if (isAuthenticated) {
      switch (flag) {
        case "member":
          // Check userDetail for member_profile_pic_url and interested_sports
          // const hasProfilePic =
          //   userDetail?.member_work_profile &&
          //   userDetail.member_work_profile !== null &&
          //   userDetail.member_work_profile.trim() !== "";
          // const hasInterestedSports =
          //   userDetail?.interested_sports &&
          //   userDetail.interested_sports.length > 0;
          // if (hasProfilePic && hasInterestedSports) {
          navigate("/dashboard/booking");
          // } else {
          // navigate("/dashboard/onboarding");
          // }
          break;
        case "admin":
          navigate("/admin/facility");
          break;
        case "facility_admin":
          navigate("/facilityadmin/dashboard");
          break;
        default:
          navigate("/login");
      }
    }
  };

  const handleLogin = (token, flag) => {
    localStorage.setItem("access_token", token);
    localStorage.setItem("flag", flag);
    setIsAuthenticated(true);
    setUserRole(flag);
    navigateToDashboard(flag);
  };

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("flag");
    setIsAuthenticated(false);
    setUserRole(null);
    navigate("/login");
  };

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, userRole, handleLogin, handleLogout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
